import {Layout} from "../../../generic/breadcrumb/breadcrumb.model";
import {BaseConfig} from "../../../../../../base/models/baseConfig";
import {CmsEndpoint} from "../../cms.endpoint";


export interface FileConfig extends BaseConfig {
  imageEndpoint: string
  imgDelEndpoint: string
}

export let defaultFileConfig: FileConfig = {
  defaultLayout: Layout.GRID,
  upsertOnDialog: true,
  showUserFilter: false,
  showDeleteButton: true,
  searchEndpoint: CmsEndpoint.FILES.IMAGE_ENDPOINT,
  imageEndpoint: CmsEndpoint.FILES.IMAGE_ENDPOINT,
  delEndpoint: CmsEndpoint.FILES.IMAGE_ENDPOINT,
  imgDelEndpoint: CmsEndpoint.FILES.IMAGE_ENDPOINT
}


export let selfRoutes = {
  list: "/cms/files",
  create: "/cms/files/create",
  update(id: number | null) {
    return id == null ? this.create : "/dash/files/" + id + '/update'
  }
}
